<template>
  <div>
    <div class="left-big-box"  style="top:0;" v-show="boxVisible">
      <strong class="top-small-text"></strong>

      <div class="left-small-box first" style="height:30%" v-show="weatherData.propertiesR.length<1">
        <div class="top-box">
          <img src="../image/homePage/icon.png" class="shu-icon" />
          <div class="top-big-text">气象数据</div>
          <div class="top-right-box">
            <div class="heng-line"></div>
          </div>
        </div>
        <div class="bottom-box" style="margin-top:10px;" >

          <div class="bottom-small-box" v-for="item in tqArr" >
            <div class="bottom-top-text"> {{item.tmp.min}}~{{item.tmp.max}} ℃</div>
            <div>
              <img  :src="item.iconSrc"  class="icon-box" /><!--@click="ShowChart(item)"-->
            </div>
            <div class="bottom-top-text">
              <div class="bottom-top-title">{{item.date}} </div>
              <div class="bottom-top-dan-text"></div>
            </div>
          </div>

        </div>
      </div>

      <div class="left-small-box first" style="height:30%" v-show="weatherData.propertiesR.length>0">
        <div class="top-box">
          <img src="../image/homePage/icon.png" class="shu-icon" />
          <div class="top-big-text">气象数据</div>
          <div class="top-right-box">
            <div class="heng-line"></div>
          </div>
        </div>
        <div class="bottom-box" style="margin-top:10px;" >

          <div class="bottom-small-box"  v-for="item in weatherData.propertiesR" :key="item.ID" >
            <div class="bottom-top-text"> {{item.name}}</div>
            <div>
              <img :src="item.cIcon"  @click="ShowChars(item)"  class="icon-box" /><!--@click="ShowChart(item)"-->
            </div>
            <div class="bottom-top-text">
              <div class="bottom-top-title">{{item.dataValue}}</div>
              <div class="bottom-top-dan-text"></div>
            </div>
          </div>

        </div>
      </div>
      <!-- 中间 -->
      <div class="left-small-box" style="height:30%" v-show="weatherData.propertiesR.length>0">

        <div class="top-box">
          <img src="../image/homePage/icon.png" class="shu-icon" />
          <div class="top-big-text">{{charsTitle}}</div>
          <div class="top-right-box">
            <div class="heng-line"></div>
          </div>
        </div>

        <div class="bottom-box-mid">

            <div id="c1" style="margin-left: 90px;margin-top: -35px;"></div>
          </div>

      </div>
      <!-- three -->
      <div class="left-small-box" style="height:30%">
        <div class="top-box">
          <img src="../image/homePage/icon.png" class="shu-icon" />
          <div class="top-big-text">消息管理</div>
          <div class="top-right-box">
            <div class="heng-line"></div>
          </div>
        </div>

        <div class="bottom-box-third" style="margin-top:10px;" >
          <div class="bottom-box-third-line-x"  v-for="(item,index) in NoticeBoxData.dataNotice" :key="index">
            <div class="bottom-box-third-text" >
              <div>{{item.deviceName}}</div>
              <div>{{item.statusDes}}</div>
              <div>{{item.time}}</div>
            </div>
            <div class="time-minute"></div>
          </div>

        </div>
      </div>
    </div>
    <!-- 右半部分 -->
    <div class="right-tan-box"   style="display:none;">
      <img class="background" src="../image/homePage/hbg.png" />
      <div class="top-famen">
        <img class="famen-icon" src="../image/homePage/famen.png" />
        <div style="margin-left:20px">电磁阀[3117110002-2]</div>
      </div>

      <!-- xin -->
      <div class="sl-cgq-single">
        <div class>灌溉模式</div>

        <div class="seemore">查看很多</div>
      </div>
      <!-- 2 -->
      <div class="container-big-box">
        <div class="sl-cgq-single-box" style="margin-left:-30px;">
          <div class="container-small-line">
            <img src="../image/homePage/rIcon.png" class="container-img" />
            <div class="title">智能</div>
          </div>
        </div>
        <div class="sl-cgq-single-box">
          <div class="container-small-line">
            <img src="../image/homePage/qIcon.png" class="container-img" />
            <div class="title">手动</div>
          </div>
        </div>
        <!-- 3 -->
        <div class="sl-cgq-single-box">
          <div class="container-small-line">
            <img src="../image/homePage/wIcon.png" class="container-img" />
            <div class="title">指令：关闭</div>
          </div>
        </div>

        <div class="sl-cgq-single-box">
          <div class="container-small-line">
            <img src="../image/homePage/tIcon.png" class="container-img" />
            <div class="title">状态：关闭</div>
          </div>
        </div>
        <!-- 4 -->
        <div class="sl-cgq-single-box">
          <div class="container-small-line">
            <img src="../image/homePage/yIcon.png" class="container-img" />
            <div class="title">网络：离线</div>
          </div>
        </div>

        <div class="sl-cgq-single-box">
          <div class="container-small-line">
            <img src="../image/homePage/eIcon.png" class="container-img" />
            <div class="title">报警：正常</div>
          </div>
        </div>
        <!--  -->
      </div>
      <img src="../image/homePage/guanbiIcon.png" class="shut" />
    </div>
    <div class="button">
      <img src="../image/allButton.png" class="button-img-box">
      <div class="updata" @click="showAllBox()">{{this.buttonText}}实时数据</div>
    </div>
    <!-- 隐藏地图 -->
    <div class="right-tan-box-x" style="display: none;">
      <img class="background" src="../image/homePage/hbg.png" />
      <div class="top-famen">
        <div style="margin-left:20px">电磁阀[3117110002-2]</div>
      </div>
      <!-- 温度 -->
      <div class="bottom-hot-box">
        <div v-for="(item,index) in propertiesR" :key="index" class="sl-cgq-single-x">
          {{item.name}}:{{item.dataValue}}
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Chart } from '@antv/g2'
import { _getProductData, _getThingModels, _getDevices, _getDevicePropData, _getDeviceNoticeData } from '@/common/request.js'

const columns = [

  {
    title: '时间',
    dataIndex: 'time',
    key: 'time'
  },
  {
    title: '原始值',
    dataIndex: 'value',
    key: 'value'
  }
]

const data = [
  {
    key: '1',
    num: 'TradeCode21',
    name: '溶解氧传感器',
    time1: '95.55',
    time2: '95.55',
    time3: '95.55',
    time4: '95.55'
  },
  {
    key: '2',
    num: 'TradeCode21',
    name: '溶解氧传感器',
    time1: '95.55',
    time2: '95.55',
    time3: '95.55',
    time4: '95.55'
  },
  {
    key: '3',
    num: 'TradeCode21',
    name: '溶解氧传感器',
    time1: '95.55',
    time2: '95.55',
    time3: '95.55',
    time4: '95.55'
  },

  {
    key: '4',
    num: 'TradeCode21',
    name: '溶解氧传感器',
    time1: '95.55',
    time2: '95.55',
    time3: '95.55',
    time4: '95.55'
  },

  {
    key: '5',
    num: 'TradeCode21',
    name: '溶解氧传感器',
    time1: '95.55',
    time2: '95.55',
    time3: '95.55',
    time4: '95.55'
  }
]

const data2 = [
  { time: '1991', value: '3' },
  { time: '1992', value: '4' },
  { time: '1993', value: '3.5' },
  { time: '1994', value: '6' },
  { time: '1995', value: '4.9' },
  { time: '1996', value: '6' },
  { time: '1997', value: '7' },
  { time: '1998', value: '9' },
  { time: '1999', value: '13' }
]
export default {
  data () {
    return {
      tqArr: [],
      charsTitle: '',
      chart: {},
      deviceData: {
        queryInfo: {
          productkey: '',
          devicename: '',
          limit: 1
        },
        queryInfoList: {
          productkey: '',
          devicename: '',
          identifier: '',
          startDate: '1900-01-01',
          endDate: '1900-01-01',
          page: 0,
          limit: 0,
          timeType: 1
        },
        devices: {},
        proDataTime: '',
        propertiesR: [],
        dataList: [],
        timer: '', // 定时器
        timerList: ''
      },
      boxVisible: true,
      buttonText: '关闭',
      // 气象数据
      weatherData: {
        queryInfo: {
          productkey: '',
          devicename: '',
          limit: 1
        },
        devices: {},
        propertiesR: [],
        data: {},
        timer: ''// 定时器
      },
      // 设备一数据
      deviceOneData: {
        queryInfo: {
          productkey: '',
          devicename: '',
          limit: 1
        },
        queryInfoNotice: {
          productkey: '',
          devicename: '',
          limit: 2,
          page: 1
        },
        devices: {},
        propertiesR: [],
        dataNotice: [],
        timer: '', // 定时器
        timerNotice: ''
      },
      // 设备二数据
      deviceTwoData: {
        queryInfo: {
          productkey: '',
          devicename: '',
          limit: 1
        },
        queryInfoNotice: {
          productkey: '',
          devicename: '',
          limit: 2,
          page: 1
        },
        devices: {},
        propertiesR: [],
        dataNotice: [],
        timer: '', // 定时器
        timerNotice: ''
      },
      // 设备三数据
      deviceThreeData: {
        queryInfo: {
          productkey: '',
          devicename: '',
          limit: 1
        },
        queryInfoNotice: {
          productkey: '',
          devicename: '',
          page: 1,
          limit: 2
        },
        devices: {},
        propertiesR: [],
        dataNotice: [],
        timer: '', // 定时器
        timerNotice: ''
      },
      // 通知数据
      NoticeBoxData: {
        queryInfoNotice: {
          productkey: '',
          devicename: '',
          devicenames: '',
          page: 1,
          limit: 2,
          cEntID: ''
        },
        dataNotice: [],
        timer: ''// 定时器
      },
      queryInfo: {
        productkey: '',
        devicename: '',
        keyword: '',
        cEntID: ''
      }
    }
  },
  async mounted () {
    this.createLine()
    // this.getHight()

    this.queryInfo.cEntID = this.$store.getters.User.enterprise.ID

    this.getDevices()

    this.weatherData.timer = setInterval(this.getDevices, 10000)// 定时10秒

    // this.deviceOneData.timer = setInterval(this.getDeviceOneData, 10000);//定时10秒
    // this.deviceTwoData.timer = setInterval(this.getDeviceTwoData, 10000);//定时10秒
    //  this.deviceThreeData.timer = setInterval(this.getDeviceThreeData, 10000);//定时10秒
    //
    // this.deviceOneData.timerNotice = setInterval(this.getDeviceOneNoticeData, 10000);//定时10秒
    // this.deviceTwoData.timerNotice = setInterval(this.getDeviceTwoNoticeData, 10000);//定时10秒
    // this.deviceThreeData.timerNotice = setInterval(this.getDeviceThreeNoticeData, 10000);//定时10秒
    // this.NoticeBoxData.timer=setInterval(this.getNoticeBoxNoticeData, 10000);//定时10秒

    setInterval(this.getTq, 10000)
    this.getTq()
  },
  methods: {
    async getTq () {
      const that = this
      try {
        // while (!this.$store.getters.SCene.ID){

        // }
        const res = await this.$http.post('WLWDevice/GetWeather2?SCeneID=' + this.$store.getters.SCene.ID)

        const tqjSON = JSON.parse(res.data.message)

        this.tqArr = tqjSON.result.HeWeather5[0].daily_forecast

        const newWeatherList = []
        this.tqArr.map((item, index) => {
          let imgSrc
          switch (item.cond.txt_d) {
            case '多云':
              imgSrc = require('../img/dpsj/weatherIcon/dy.png')
              break

            case '雷阵雨':
              imgSrc = require('../img/dpsj/weatherIcon/leizhenyu.png')
              break

            case '阴':
              imgSrc = require('../img/dpsj/weatherIcon/yin.png')
              break

            case '晴':
              imgSrc = require('../img/dpsj/weatherIcon/qing.png')
              break

            default:
              imgSrc = require('../img/dpsj/weatherIcon/dy.png')
          }
          newWeatherList.push(
            Object.assign(item, { iconSrc: imgSrc })
          )
        })
        that.weatherToday = newWeatherList[0]
        that.weatherOtherDay = newWeatherList.slice(1, 4)
      } catch (e) {
        console.log('e', e)
      }
    },
    createLine: function () {
      // Step 1: 创建 Chart 对象
      this.chart = new Chart({
        container: 'c1',
        autoFit: true,
        width: 400,
        height: 170,
        padding: [30, 100, 30, 40]
      })

      // Step 2: 载入数据源
      // this.chart.data(data2);
      this.chart.changeData(this.deviceData.dataList)
      // Step 3：创建图形语法，绘制柱状图
      // this.chart.interval().position('genre*sold');
      // var pro=this.deviceData.propertiesR.filter(x=>x.identifier==this.deviceData.queryInfoList.identifier)
      // if(pro!=null){
      //   min=this.utils.formatNumber(pro[0].dataSpecs.min)
      //   max=this.utils.formatNumber(pro[0].dataSpecs.max)
      //   step=this.utils.formatNumber(pro[0].dataSpecs.step)
      // }
      // min=0.0
      //   max=20.0
      //   step=0.01
      this.chart.scale({
        time: {
          range: [0.05, 0.95],
          type: 'time',
          mask: 'MM-DD hh:mm:ss',
          nice: true
        },
        value: {
          // min: min,
          // max:max,
          // tickInterval: step,
          nice: true
        }
      })
      this.chart.tooltip({
        showCrosshairs: true, // 展示 Tooltip 辅助线
        shared: true
      })
      // this.chart.line().position('year*value').label('value');
      // this.chart.point().position('year*value');
      this.chart.line().position('time*value')
      this.chart.point().size(2).position('time*value')
      // Step 4: 渲染图表
      this.chart.render()
    },
    reloadDrawing: function () {
      // 销毁画布对象
      this.chart.destroy()
      // 重新调用数据进行加载
      this.createLine()
    },
    async ShowChars (item) {
      this.charsTitle = item.name

      /*
*
*
* */

      /*
*    devicename: "",
          endDate: "2020-10-02",
          identifier: "BatV",
          limit: 0,
          page: 0,
          productkey: "a1QdayAsVWc",
          startDate: "2020-10-01",
          timeType: 1

* */
      const hide = this.$message.loading('正在获取设备数据请稍候..', 0)
      const res = await this.$http.post('WLWDevice/DevicePropertyDataChartListByIndex', {

        devicename: '',
        endDate: '2020-09-15',
        identifier: item.identifier,
        limit: 0,
        page: 0,
        productkey: item.productKey,
        startDate: '2020-09-10',

        timeType: 1

      })

      setTimeout(hide, 100)
      if (res != null) {
        const data = res.data.obj.list

        this.deviceData.dataList.splice(0)

        if (data != null && data.length > 0) {
          data.forEach(element => {
            const item = {
              time: element.time,
              value: this.utils.formatNumber(element.values, 1)
            }
            this.deviceData.dataList.push(item)
          })
        }

        this.chart.render()
      } else {
        this.$message.error(res.message)
      }
    },
    // 返回上一级
    goLastPage () {
      this.$router.go(-1)
    },

    async getDevices () {
      const _this = this
      const res = await _getDevices(_this, _this.queryInfo)

      if (res != null) {
        const txRes = await this.$http.post('WLWDevice/SelQxz', {
          cEntID: this.$store.getters.User.enterprise.ID,
          cSystemCode: '节水灌溉'
        })
        let _tqID = ''
        let _tqKey = ''
        try {
          _tqID = txRes.data.obj._device.ID
          _tqKey = txRes.data.obj._device.ProductKey
        } catch (e) {

        }

        let devlist = res.obj.list.filter(x => x.ID == _tqID)
        if (devlist[0] != null) {
          _this.weatherData.devices = devlist[0]
          console.log('_this.weatherData', _this.weatherData)
          var ThingModels = _this.$store.getters.ThingModels.filter(x => x.productKey == _this.weatherData.devices.ProductKey)
          if (ThingModels != null && ThingModels.length > 0) {
            var propertiesR = _this.utils.deepClone(ThingModels[0].propertiesR)
            console.log('propertiesR', propertiesR)
            _this.weatherData.propertiesR = propertiesR
          }
          const _newR = []
          for (const i in _this.weatherData.propertiesR) {
            for (const j in txRes.data.obj.identifierList) {
              console.log(j, this.weatherData.propertiesR[i].identifier)
              if (txRes.data.obj.identifierList[j] == this.weatherData.propertiesR[i].identifier) {
                _newR.push(this.weatherData.propertiesR[i])
              }
            }
          }
          this.weatherData.propertiesR = _newR
          _this.weatherData.queryInfo.productkey = _this.weatherData.devices.ProductKey
          _this.weatherData.queryInfo.devicename = _this.weatherData.devices.DeviceName
          _this.getWeatherData()
        }

        devlist = res.obj.list.filter(x => x.ProductKey != _tqKey)
        if (devlist[0] != null) {
          _this.deviceOneData.devices = devlist[0]
          var ThingModels = _this.$store.getters.ThingModels.filter(x => x.productKey == _this.deviceOneData.devices.ProductKey)
          if (ThingModels != null && ThingModels.length > 0) {
            var propertiesR = _this.utils.deepClone(ThingModels[0].propertiesR)
            if (propertiesR && propertiesR.length > 4) {
              _this.deviceOneData.propertiesR = propertiesR.splice(0, 4)
            } else {
              _this.deviceOneData.propertiesR = propertiesR
            }
          }
          _this.deviceOneData.queryInfo.productkey = _this.deviceOneData.devices.ProductKey
          _this.deviceOneData.queryInfo.devicename = _this.deviceOneData.devices.DeviceName
          _this.deviceOneData.queryInfoNotice.productkey = _this.deviceOneData.devices.ProductKey
          _this.deviceOneData.queryInfoNotice.devicename = _this.deviceOneData.devices.DeviceName

          _this.getNoticeBoxNoticeData()
          _this.getDeviceOneData()
          _this.getDeviceOneNoticeData()
        }
        if (devlist[1] != null) {
          _this.deviceTwoData.devices = devlist[1]
          var ThingModels = _this.$store.getters.ThingModels.filter(x => x.productKey == _this.deviceTwoData.devices.ProductKey)
          if (ThingModels != null && ThingModels.length > 0) {
            var propertiesR = _this.utils.deepClone(ThingModels[0].propertiesR)
            _this.deviceTwoData.propertiesR = propertiesR.splice(0, 4)
          }
          _this.deviceTwoData.queryInfo.productkey = _this.deviceTwoData.devices.ProductKey
          _this.deviceTwoData.queryInfo.devicename = _this.deviceTwoData.devices.DeviceName
          _this.deviceTwoData.queryInfoNotice.productkey = _this.deviceTwoData.devices.ProductKey
          _this.deviceTwoData.queryInfoNotice.devicename = _this.deviceTwoData.devices.DeviceName

          _this.getDeviceTwoData()
          _this.getDeviceTwoNoticeData()
        }
        if (devlist[2] != null) {
          _this.deviceThreeData.devices = devlist[2]

          var ThingModels = _this.$store.getters.ThingModels.filter(x => x.productKey == _this.deviceThreeData.devices.ProductKey)

          if (ThingModels != null && ThingModels.length > 0 && ThingModels[0].propertiesR) {
            var propertiesR = _this.utils.deepClone(ThingModels[0].propertiesR)
            if (propertiesR && propertiesR.length > 4) {
              _this.deviceThreeData.propertiesR = propertiesR.splice(0, 4)
            } else {
              _this.deviceThreeData.propertiesR = propertiesR
            }
          }
          _this.deviceThreeData.queryInfo.productkey = _this.deviceThreeData.devices.ProductKey
          _this.deviceThreeData.queryInfo.devicename = _this.deviceThreeData.devices.DeviceName
          _this.deviceThreeData.queryInfoNotice.productkey = _this.deviceThreeData.devices.ProductKey
          _this.deviceThreeData.queryInfoNotice.devicename = _this.deviceThreeData.devices.DeviceName
          _this.getDeviceThreeData()
          _this.getDeviceThreeNoticeData()
        }
      }
    },
    async getWeatherData () {
      const data = await this.getDevicePropData(this.weatherData.queryInfo)

      if (data != null && data.length > 0) {
        const dataItems = data[0].dataItems
        if (this.weatherData.propertiesR != null && this.weatherData.propertiesR.length > 0) {
          this.weatherData.propertiesR.forEach(element => {
            if (element) {
              let src = ''
              if (element.cIcon) {
                src = element.cIcon
              } else {
                src = require('../img/guangzhanduIcon.png')
              }
              element.cIcon = src
              if (dataItems[element.identifier] != null) {
                const value = this.utils.formatPropData(element, dataItems[element.identifier].value)
                this.$set(element, 'dataValue', value)
              }
            }
          })
          this.ShowChars(this.weatherData.propertiesR[0])
        }
      }
    },
    async getDeviceOneData () {
      const data = await this.getDevicePropData(this.deviceOneData.queryInfo)
      if (data != null && data.length > 0) {
        const dataItems = data[0].dataItems
        if (this.deviceOneData.propertiesR != null && this.deviceOneData.propertiesR.length > 0) {
          this.deviceOneData.propertiesR.forEach(element => {
            if (dataItems[element.identifier] != null) {
              const value = this.utils.formatPropData(element, dataItems[element.identifier].value)
              this.$set(element, 'dataValue', value)
            }
          })
        }
      }
    },
    async getDeviceTwoData () {
      const data = await this.getDevicePropData(this.deviceTwoData.queryInfo)
      if (data != null && data.length > 0) {
        const dataItems = data[0].dataItems
        if (this.deviceTwoData.propertiesR != null && this.deviceTwoData.propertiesR.length > 0) {
          this.deviceTwoData.propertiesR.forEach(element => {
          // console.log(element.identifier)
            if (dataItems[element.identifier] != null) {
              const value = this.utils.formatPropData(element, dataItems[element.identifier].value)
              this.$set(element, 'dataValue', value)
            }
          })
        }
      }
    },
    async getDeviceThreeData () {
      const data = await this.getDevicePropData(this.deviceThreeData.queryInfo)
      if (data != null && data.length > 0) {
        const dataItems = data[0].dataItems
        if (this.deviceThreeData.propertiesR != null && this.deviceThreeData.propertiesR.length > 0) {
          this.deviceThreeData.propertiesR.forEach(element => {
            if (dataItems[element.identifier] != null) {
              const value = this.utils.formatPropData(element, dataItems[element.identifier].value)
              this.$set(element, 'dataValue', value)
            }
          })
        }
      }
    },
    async getDeviceOneNoticeData () {
      const data = await this.getDeviceNoticeData(this.deviceOneData.queryInfoNotice)
      if (data != null && data.length > 0) {
        if (data && data.length > 2) {
          this.deviceOneData.dataNotice = data.slice(0, 2)
        } else {
          this.deviceOneData.dataNotice = data
        }
      }
    },
    async getDeviceTwoNoticeData () {
      const data = await this.getDeviceNoticeData(this.deviceTwoData.queryInfoNotice)
      if (data != null && data.length > 0) {
        if (data && data.length > 2) {
          this.deviceTwoData.dataNotice = data.slice(0, 2)
        } else {
          this.deviceTwoData.dataNotice = data
        }
      }
    },
    async getDeviceThreeNoticeData () {
      const data = await this.getDeviceNoticeData(this.deviceThreeData.queryInfoNotice)
      if (data != null && data.length > 0) {
        if (data && data.length > 2) {
          this.deviceThreeData.dataNotice = data.slice(0, 2)
        } else {
          this.deviceThreeData.dataNotice = data
        }
      }
    },
    async getNoticeBoxNoticeData () {
      const that = this
      that.queryInfo.cEntID = that.$store.getters.User.enterprise.ID
      const names = that.$store.getters.Devices.filter(s => s.cEntID == that.queryInfo.cEntID).map(s => { return s.DeviceName })

      if (names && names.length > 0) {
        names.forEach((ele, index) => {
          that.NoticeBoxData.queryInfoNotice.devicenames += "'" + ele + "',"
        })
        that.NoticeBoxData.queryInfoNotice.devicenames = that.NoticeBoxData.queryInfoNotice.devicenames.substr(0, that.NoticeBoxData.queryInfoNotice.devicenames.length - 1)
      }
      that.NoticeBoxData.queryInfoNotice.cEntID = that.$store.getters.User.enterprise.ID
      this.NoticeBoxData.queryInfoNotice.sceneId=this.$store.getters.SCene.ID;
      const data = await this.getDeviceNoticeData(this.NoticeBoxData.queryInfoNotice)
      if (data != null && data.length > 0) {
        if (data && data.length > 2) {
          this.NoticeBoxData.dataNotice = data.slice(0, 4)
        } else {
          this.NoticeBoxData.dataNotice = data
        }
      }
    },

    async getDevicePropData (param) {
      const res = await _getDevicePropData(this, param)
      if (res != null) {
        return res.obj.list
      } else {
        this.$message.error(res.message)
        return new []()
      }
    },
    async getDeviceNoticeData (param) {
      const res = await _getDeviceNoticeData(this, param)
      if (res != null) {
        return res.obj.list
      } else {
        this.$message.error(res.message)
        return new []()
      }
    },
    getHight: function () {
      // 获取高度
      const h = document.getElementById('mochu').clientHeight
      // 获取宽度
      const w = document.getElementById('mochu').clientWidth
    },
    showAllBox: function () {
      this.boxVisible = !this.boxVisible

      if (this.boxVisible) {
        this.buttonText = '关闭'
      } else {
        this.buttonText = '开启'
      }
    },
    toNoticePage: function () {
      this.$router.push('/notice/noticeList')
    },
    toEDPage: function (IotId) {
      this.$router.push({
        path: '/equipment/equipmentDetails',
        query: {
          IotId: IotId
        }
      })
    }
  },
  beforeDestroy () {
    clearInterval(this.weatherData.timer)

    clearInterval(this.deviceOneData.timer)
    clearInterval(this.deviceTwoData.timer)
    clearInterval(this.deviceThreeData.timer)
    clearInterval(this.NoticeBoxData.timer)
    clearInterval(this.deviceOneData.timerNotice)
    clearInterval(this.deviceTwoData.timerNotice)
    clearInterval(this.deviceThreeData.timerNotice)
  }
}
</script>

<style>
  .ls-all-box{
    /* position: fixed ; */

    /*z-index: 999;*/
    /*padding:2% 1%;*/
    /*height: 100%;*/
    /*width: 100%;*/
    /*display: flex;*/
    /*flex-direction: column;*/
    /*justify-content: space-between;*/
    /*align-items: flex-end;*/

  }

  .ls-one-box{
    width: 100%;
    display: flex;
    justify-content: space-between;

  }

  /*.all-button-box{*/
  /*  position: relative;*/
  /*}*/

  /*.all-button-text{*/
  /*  color: white;*/
  /*  position: absolute;*/
  /*  top: 12px;*/
  /*  left:69px;*/
  /*  cursor: pointer;*/
  /*}*/

  /*.ls-button-box{*/
  /*  cursor: pointer;*/
  /*  width: 220px;*/
  /*}*/

  /*.ls-weather-box{*/
  /*  color: white;*/
  /*  position: relative;*/
  /*  width: 25%;*/
  /*  display: flex;*/
  /*}*/

  .lss-li-all-box{
    /*绝对定位*/
    position: absolute;
    width: 100%;
    height: 100%;
    padding: 20px;
    /*top:10%;*/
    /*left: 8%;*/
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    /*align-items: start;*/
    /*flex-wrap: wrap*/
    font-size: 90%;
  }

  .lss-li-title-box{
    display: flex;
    justify-content: space-between;
  }

  .lss-title-text-box{
    border: 1px solid rgba(255,255,255,0.5);
    border-radius: 2px;
    padding: 2px;

  }

  .lss-tu-all-box{
    display: flex;
    justify-content: space-around;
    padding: 2% 0;
  }

  /*.lss-tu-single-box{*/
  /*  !*background: url("../img/yuanBg.png") no-repeat  center;*!*/
  /*  padding:3% 3%;*/
  /*  font-size: 65%;*/
  /*  text-align: center;*/

  /*}*/

  .lss-bottom-all-box{
    display: flex;
    justify-content: space-between;
  }

  .lss-bottom-single-box{
    /*display: flex;*/
  }

  .lss-bottom-single-img{
    width: 70px;
    /*padding-left: 2%;*/
  }

  .lss-drop-all-box{
    position: absolute;
    top:61%;
    left: 3%;
    padding: 7px 10px;
    border-radius: 5px;
    /*background:rgb(10,57,99);*/
    background:linear-gradient(#0A3560, #154970);
  }

  .lss-drop-box{
    color: white!important;
    margin: 7px 30px;
  }

  .ss-drop-menu{
    background:linear-gradient(#0A3560, #154970);
    width: 100%;
  }

</style>
